export const removeItemFromObject = (obj, ...keys) => {
  return Object.keys(obj).reduce((acc, curr) => {
    return {
      ...acc,
      ...(keys.includes(curr) ? {} : { [curr]: obj[curr] }),
    };
  }, {});
};
